import React, { useEffect, useMemo } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { handleDetailActiveRevenueDownloadFilterParamsToApi } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import ActiveuserContext from '../index';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  getDetailCommonValidUrlParams,
  getCountriesActiveuserRevDownValidUrlParams,
  statsActiveuserValidCfg,
  countriesActiveuserValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import { useShortLink } from '@intelligence/hooks/useShortLink';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';
import { MOBILE_STATS_OPINION_EVENT_FILTER_KEY } from '../../useMobileStatsOpinionEvents';

export default function Activeuer(props: any) {
  const { tabType, pageId } = props;
  const isCoutriesPage = tabType === 'countries';
  const currentValidCfg = isCoutriesPage ? countriesActiveuserValidCfg : statsActiveuserValidCfg;
  const getValidUrlParams = isCoutriesPage
    ? getCountriesActiveuserRevDownValidUrlParams
    : getDetailCommonValidUrlParams;
  // 是否有短链接更新功能
  const hasUrlShortLink = isCoutriesPage
    ? hasShortLinkRatio.detailMobileCountriesActiveuser
    : hasShortLinkRatio.detailMobileStatsActiveuser;

  if (pageId !== 'activeusers') {
    return null;
  }

  return (
    <ActiveuerRevDownCom
      {...props}
      hasUrlShortLink={hasUrlShortLink}
      isCoutriesPage={isCoutriesPage}
      currentValidCfg={currentValidCfg}
      getValidUrlParams={getValidUrlParams}
      chartSegment={'avg_dau'}
    />
  );
}

export function ActiveuerRevDownCom(props: any) {
  const {
    isCalibrated,
    appIds,
    currentValidCfg,
    getValidUrlParams,
    isCoutriesPage,
    hasUrlShortLink,
    chartSegment,
    urlFilterValue,
    entityType,
    enableRevenueScope = false,
  } = props;
  const { filterLoading, regionOptions } = useMarketFilterApi({});

  const {
    initShortLinkCfgNoAwait,
    shortLinkLoading,
    urlCustomParams,
    shortLinkFilterValue,
    shortLinkValidQuery,
  } = useShortLink({
    urlFilterValue,
    hasUrlShortLink,
    getPageValidCfg: () => currentValidCfg,
    getCustomValidUrlParams: getValidUrlParams,
  });

  useEffect(() => {
    // 进入页面时判断是否有tokenQuery等，有则进入
    initShortLinkCfgNoAwait();
  }, []);

  const defaultFilterValue = useMemo(
    () => ({
      [filterKeyMap.REGION]: {
        regions: [],
        markets: ['global'],
        type: 'market',
      },
      [filterKeyMap.DATASOURCESIM]: {
        value: isCalibrated ? 'ogdb' : 'sensortower',
      },
      [filterKeyMap.RANGE_TIME]: {
        type: 'date',
        value: ['', ''],
      },
      [filterKeyMap.PLATFORM]: { value: ['appstore', 'googleplay'] },
      [filterKeyMap.REVENUE_SCOPE]: { value: REVENUE_SCOPE_VALUES.EXCLUDING },
    }),
    [isCalibrated],
  );

  const filterKeyList = useMemo(
    () => [
      filterKeyMap.RANGE_TIME,
      filterKeyMap.REGION,
      filterKeyMap.DATASOURCESIM,
      filterKeyMap.PLATFORM,
      ...(enableRevenueScope
        ? [MOBILE_STATS_OPINION_EVENT_FILTER_KEY, filterKeyMap.REVENUE_SCOPE]
        : []),
    ],
    [enableRevenueScope],
  );

  const filterCfg: TopchartFilterCfgType = useMemo(
    () => ({
      filterKeyList,
      regionFilterParams: {},
      defaultValue: defaultFilterValue,
      resetFilterValue: {
        ...defaultFilterValue,
      },
      specialParams: {
        regionOptions, // 国家筛选器options,
        defalutMarket: ['global'], // 没取到交集用的默认值
        disableNoChina: false,
        rangeTimeType: FilterTimeType.commonRange,
        isShowAlloftime: false,
        showShortcut: true,
        [filterKeyMap.DATASOURCESIM]: {
          showDatabrain: isCalibrated,
        },
        [filterKeyMap.REVENUE_SCOPE]: {
          controlType: 'switch',
          visible: 2,
        },
        entityType,
      },
      showConfirmButton: false,
      haveFilterSaveBtn: false,
      handleFilterToApiParams: handleDetailActiveRevenueDownloadFilterParamsToApi,
      hasUrlShortLink,
    }),
    [filterKeyList, hasUrlShortLink, isCalibrated, defaultFilterValue, regionOptions],
  );

  return (
    <ActiveuserContext
      {...props}
      isCoutriesPage={isCoutriesPage}
      filterLoading={filterLoading || shortLinkLoading}
      // 筛选器相关配置如筛选器展示顺序，默认值等
      filterCfg={filterCfg}
      // 从短链接中拿到校正后的url参数（与页面相关）
      urlCustomParams={urlCustomParams}
      // 筛选器有效的页面配置值
      shortLinkValidQuery={shortLinkValidQuery}
      // 从短链接拿到的筛选器分享值
      shortLinkFilterValue={shortLinkFilterValue}
      showRankSwitch={appIds?.length === 1}
      chartSegment={chartSegment}
    />
  );
}
